import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ReactTooltip from 'react-tooltip';
import { uploadImages, uploadVideo } from 'redux/modules/composebox';
import { addImage, removeImage, orgInitialState } from 'redux/modules/groupPostCompose';
import { Spinner, Tooltip } from 'components';
import { ImagePickerContainer } from 'containers';
import * as styles from './Group.scss';

var Dropzone = require('react-dropzone');

var GImagePostSection = (_dec = connect(function (state) {
  var orgId = state.organization.current.id;
  return {
    config: state.config,
    groupPost: state.groupPostCompose,
    organization: state.organization.current,
    organizationId: state.organization.current.id,
    uploadingImage: state.composebox.uploadingImage
  };
}, {
  addImage: addImage,
  removeImage: removeImage,
  uploadImages: uploadImages
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(GImagePostSection, _Component);

  var _super = _createSuper(GImagePostSection);

  function GImagePostSection(props) {
    var _this;

    _classCallCheck(this, GImagePostSection);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleImages", function (images) {
      images.forEach(function (obj) {
        _this.props.addImage(obj.fullyQualifiedUrl, _this.props.organizationId);
      });
    });

    _this.state = {
      maxImageCount: 4
    };
    return _this;
  }
  /** *********************************************************
   EVENT HANDLERS
   ***********************************************************/

  /** *********************************************************
   CUSTOM METHODS
   ***********************************************************/


  _createClass(GImagePostSection, [{
    key: "render",
    value:
    /** *********************************************************
     RENDER
     ***********************************************************/
    function render() {
      var _this2 = this;

      var groupPost = this.props.groupPost;
      var imgTags = groupPost.images.map(function (url, idx) {
        return /*#__PURE__*/React.createElement("div", {
          style: {
            position: 'relative'
          },
          key: idx
        }, /*#__PURE__*/React.createElement("div", {
          className: styles.imageCloseBtn,
          onClick: function onClick() {
            return _this2.props.removeImage(idx, _this2.props.organizationId);
          }
        }, /*#__PURE__*/React.createElement("i", {
          className: "icon ion-ios-close-empty ".concat(styles.imageCloseBtnIcon)
        })), /*#__PURE__*/React.createElement("div", {
          className: styles.uploadedImage,
          style: {
            backgroundImage: "url(".concat(url, ")")
          }
        }));
      });
      return /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12"
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12"
      }, /*#__PURE__*/React.createElement("h4", {
        style: {
          color: '#8b8b8b'
        }
      }, "Upload Images", groupPost && groupPost.images && groupPost.images.length > 1 && /*#__PURE__*/React.createElement(Tooltip, {
        message: "Multi-image posts may look different in the preview than social networks."
      }), groupPost && groupPost.images && !!groupPost.images.find(function (i) {
        return i.indexOf('.gif') !== -1;
      }) && /*#__PURE__*/React.createElement(Tooltip, {
        message: "A post may only contain one GIF image."
      })), /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          flexWrap: 'wrap',
          width: 545,
          minHeight: 125,
          position: 'relative'
        }
      }, imgTags, groupPost.images.length !== this.state.maxImageCount && !this.props.uploadingImage && (!groupPost.images || groupPost.images.length === 0 || groupPost.images && !groupPost.images.find(function (i) {
        return i.indexOf('.gif') !== -1;
      })) && /*#__PURE__*/React.createElement(ImagePickerContainer, {
        parentImageHandler: this.handleImages,
        buttonText: "Add Image",
        maxImageCount: this.state.maxImageCount - groupPost.images.length
      }), this.props.uploadingImage && /*#__PURE__*/React.createElement(Spinner, {
        center: true
      })))));
    }
  }]);

  return GImagePostSection;
}(Component)) || _class);
export { GImagePostSection as default };